import { ChangeEvent, useRef, useState } from 'react';
import { Button } from 'react-bootstrap';
import { FormData } from '../../../types';
import { parseErvJson } from './jsonImport';

interface Props {
  onUpload: (data: Pick<FormData, 'password' | 'companies'>) => void;
}

const isJsonUploadEnabled = () =>
  new URLSearchParams(window.location.search).get('json') === 'true';

const JsonUploadButton = ({ onUpload }: Props) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [error, setError] = useState<string | null>(null);

  if (!isJsonUploadEnabled()) {
    return null;
  }

  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    // allow re-selecting the same file
    e.target.value = '';
    if (!file) {
      return;
    }
    const reader = new FileReader();
    reader.onload = () => {
      try {
        const json = JSON.parse(reader.result as string);
        const parsed = parseErvJson(json);
        setError(null);
        onUpload(parsed);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Neispravan JSON.');
      }
    };
    reader.onerror = () => {
      setError('Datoteku nije moguće pročitati.');
    };
    reader.readAsText(file);
  };

  return (
    <div className="frow ac mgb">
      <input
        type="file"
        accept="application/json,.json"
        ref={inputRef}
        style={{ display: 'none' }}
        onChange={handleFileChange}
      />
      <Button
        className="btn-sm btn-secondary mgr"
        onClick={() => inputRef.current?.click()}
      >
        Uvezi JSON
      </Button>
      {error && <span className="text-danger">{error}</span>}
    </div>
  );
};

export default JsonUploadButton;
